module.exports = __webpack_public_path__ + "static/media/special-thanks.e7114cc7.md";